import { Component, OnInit, Input } from '@angular/core';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { Audit } from '../../audit.model';
import { AuditService } from '../../audit.service';
import { MatDialog } from '@angular/material';
import { filter } from 'rxjs/operators';
import { AuditEditDialogComponent } from '../audit-edit-dialog/audit-edit-dialog.component';

@Component({
  selector: 'iaud-audit-detail-expansion',
  templateUrl: './audit-detail-expansion.component.html',
  styleUrls: ['./audit-detail-expansion.component.scss']
})
export class AuditDetailExpansionComponent implements OnInit {

  dateFormat: string = DISPLAY_DATE_FORMAT;

  _audit: Audit;
 canUpdate:boolean;

  @Input()
  set audit(a: Audit) { 
    this._audit = a; 
    this.canUpdate = this._audit.canUpdate;
  }
  get audit(): Audit { return this._audit; }

  constructor(
    private dialog: MatDialog,
    private auditService: AuditService
  ) { }

  ngOnInit() {    

  }

  editAudit(): void {

    const dialogRef = this.dialog.open(AuditEditDialogComponent, { data: { audit: this._audit } });

    dialogRef.afterClosed()
      .pipe(
        filter(res => res && res.success)
      )
      .subscribe(res => {
        this.auditService.getAudit(res.audit)
          .subscribe(o => this.audit = o);
      });
  }

}
